import { storage } from '@visiba/std';

export const devLocalStorage = storage({ prefix: '' });
